let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gvhOi")).then(() => parcelRequire('bTtSx'));